// extracted by mini-css-extract-plugin
export default {"container":"sidebarComponent_container__--0+i","vkLogo":"sidebarComponent_vkLogo__APtm4"};